(function () {
  'use strict';

  var BAND_COLORS = {
    'black':        '#202020',
    'navy':         '#1e3868',
    'hunter':       '#375955',
    'hunter green': '#375955',
    'olive':        '#454411',
    'olive green':  '#454411',
    'fog':          '#C0C5D1',
    'fog grey':     '#C0C5D1',
    'white':        '#f5f3f0',
    'ice':          '#BEF1FA',
    'ice blue':     '#BEF1FA',
    'blush':        '#c9a09a',
    'rose':         '#D95C8C',
    'vibrant pink': '#e0207a',
    'coral':        '#e86070',
    'lavender':     '#9e86c0',
    'rust':         '#c04818',
    'poppy':        '#cc1e1e',
    'crimson':      '#8b1820',
    'mint':         '#5ab870'
  };

  var LIGHT_BAND_COLORS = ['white', 'ice', 'ice blue', 'blush', 'fog', 'fog grey'];

  var MONO_FONT_SETS = {
    round: {
      left:   'MonoRoundLeft',
      center: 'MonoRoundCenter',
      right:  'MonoRoundRight'
    },
    scallop: {
      left:   'MonoScallopLeft',
      center: 'MonoScallopCenter',
      right:  'MonoScallopRight'
    }
  };

  var STYLE_LABELS = {
    round:   'Classic Round',
    scallop: 'Scallop'
  };

  var FRAME_DATA_ATTRS = {
    'scallop':          'frame-scallop',
    'double-circle':    'frame-double-circle',
    'hearts':           'frame-hearts',
    'hearts-arrows':    'frame-hearts-arrows',
    'bow':              'frame-bow',
    'paw':              'frame-paw',
    'butterfly-floral': 'frame-butterfly-floral',
    'angel':            'frame-angel',
    'nurse':            'frame-nurse',
    'laurel':           'frame-laurel',
    'butterfly-laurel': 'frame-butterfly-laurel'
  };

  // State
  var state = {
    style:       'round',
    first:       '',
    last:        '',
    middle:      '',
    frame:       'none',
    nameEnabled: false,
    name:        '',
    nameFont:    'BandFontCollege',
    nameFontLabel: 'College',
    isLight:     false
  };

  // DOM refs
  var root, bandLong, bandShort,
      monoL, monoC, monoR,
      frameOverlay, nameDisplay, namePlaceholder,
      styleValueInput, initialsValueInput,
      frameValueInput, nameValueInput, nameFontValueInput;

  function el(id) { return document.getElementById(id); }

  function init() {
    root = document.querySelector('[data-mb-root]');
    if (!root) return;

    bandLong        = el('mb-preview-band');
    bandShort       = el('mb-preview-band-short');
    monoL           = el('mb-mono-l');
    monoC           = el('mb-mono-c');
    monoR           = el('mb-mono-r');
    frameOverlay    = el('mb-frame-overlay');
    nameDisplay     = el('mb-name-display');
    namePlaceholder = el('mb-name-placeholder');
    styleValueInput    = el('mb-style-value');
    initialsValueInput = el('mb-initials-value');
    frameValueInput    = el('mb-frame-value');
    nameValueInput     = el('mb-name-value');
    nameFontValueInput = el('mb-name-font-value');

    bindStyleTabs();
    bindInitials();
    bindFrameOptions();
    bindNameToggle();
    bindNameInput();
    bindFontButtons();
    bindColorSync();

    // Detect initial variant color
    var initialColor = detectCurrentColor();
    if (initialColor) applyBandColor(initialColor);

    renderPreview();
  }

  // --- Style tabs ---
  function bindStyleTabs() {
    var tabs = root.querySelectorAll('.mb-style-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        state.style = tab.dataset.style;
        styleValueInput.value = STYLE_LABELS[state.style] || state.style;
        renderMonogram();
      });
    });
  }

  // --- Initials ---
  function bindInitials() {
    var inputs = [
      { el: el('mb-initial-first'),  key: 'first' },
      { el: el('mb-initial-last'),   key: 'last' },
      { el: el('mb-initial-middle'), key: 'middle' }
    ];
    inputs.forEach(function (item) {
      if (!item.el) return;
      item.el.addEventListener('input', function () {
        state[item.key] = this.value.toUpperCase().replace(/[^A-Z]/gi, '').slice(0, 1);
        this.value = state[item.key];
        updateInitialsHidden();
        renderMonogram();

        // Auto-advance to next field
        if (state[item.key] && item.key === 'first') el('mb-initial-last').focus();
        else if (state[item.key] && item.key === 'last') el('mb-initial-middle').focus();
      });
    });
  }

  function updateInitialsHidden() {
    // Order for engraving: First - Last(center) - Middle
    var str = state.first + state.last + state.middle;
    initialsValueInput.value = str;
  }

  // --- Frame options ---
  function bindFrameOptions() {
    var options = root.querySelectorAll('.mb-frame-option');
    options.forEach(function (opt) {
      opt.addEventListener('click', function () {
        options.forEach(function (o) { o.classList.remove('is-selected'); });
        opt.classList.add('is-selected');
        state.frame = opt.dataset.frame;
        var label = opt.querySelector('.mb-frame-label');
        frameValueInput.value = label ? label.textContent.trim() : state.frame;
        renderFrame();
      });
    });
  }

  // --- Name toggle ---
  function bindNameToggle() {
    var toggle = el('mb-name-toggle');
    var fields = el('mb-name-fields');
    if (!toggle || !fields) return;
    toggle.addEventListener('change', function () {
      state.nameEnabled = this.checked;
      if (this.checked) {
        fields.removeAttribute('hidden');
      } else {
        fields.setAttribute('hidden', '');
        state.name = '';
        nameValueInput.value = '';
        nameFontValueInput.value = '';
      }
      renderName();
    });
  }

  // --- Name input ---
  function bindNameInput() {
    var input = el('mb-name-text');
    var counter = el('mb-name-char-count');
    if (!input) return;
    input.addEventListener('input', function () {
      state.name = this.value;
      nameValueInput.value = this.value;
      if (counter) counter.textContent = this.value.length;
      renderName();
    });
  }

  // --- Font buttons ---
  function bindFontButtons() {
    var btns = root.querySelectorAll('.mb-font-btn');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.nameFont = btn.dataset.fontFamily;
        state.nameFontLabel = btn.dataset.fontLabel;
        nameFontValueInput.value = state.nameFontLabel;
        renderName();
      });
    });
  }

  // --- Color sync ---
  function detectCurrentColor() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      var v = radios[i].value.toLowerCase();
      if (BAND_COLORS[v]) return v;
    }
    var selects = document.querySelectorAll('variant-selects select, .product-form select');
    for (var j = 0; j < selects.length; j++) {
      var v2 = selects[j].value.toLowerCase();
      if (BAND_COLORS[v2]) return v2;
    }
    return null;
  }

  function applyBandColor(colorName) {
    var hex = BAND_COLORS[colorName];
    if (!hex) return;
    if (bandLong)  bandLong.style.backgroundColor  = hex;
    if (bandShort) bandShort.style.backgroundColor = hex;

    state.isLight = LIGHT_BAND_COLORS.indexOf(colorName) !== -1;
    var textColor = state.isLight ? 'rgba(0,0,0,0.45)' : 'rgba(255,255,255,0.8)';

    var monoDisplay = el('mb-mono-display');
    if (monoDisplay) monoDisplay.style.color = textColor;
    if (nameDisplay) nameDisplay.style.color = textColor;

    // Frame blend mode
    if (frameOverlay) {
      if (state.isLight) {
        frameOverlay.style.filter = '';
        frameOverlay.style.mixBlendMode = 'multiply';
      } else {
        frameOverlay.style.filter = 'invert(1)';
        frameOverlay.style.mixBlendMode = 'screen';
      }
    }
  }

  function bindColorSync() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type === 'radio' || t.tagName === 'SELECT') {
        var v = t.value.toLowerCase();
        if (BAND_COLORS[v]) {
          applyBandColor(v);
        } else {
          var found = detectCurrentColor();
          if (found) applyBandColor(found);
        }
      }
    });
  }

  // --- Render functions ---
  function renderMonogram() {
    var fonts = MONO_FONT_SETS[state.style] || MONO_FONT_SETS.round;
    if (monoL) {
      monoL.style.fontFamily = "'" + fonts.left + "', serif";
      monoL.textContent = state.first || 'F';
    }
    if (monoC) {
      monoC.style.fontFamily = "'" + fonts.center + "', serif";
      monoC.textContent = state.last || 'L';
    }
    if (monoR) {
      monoR.style.fontFamily = "'" + fonts.right + "', serif";
      monoR.textContent = state.middle || 'M';
    }
  }

  function renderFrame() {
    if (!frameOverlay) return;
    if (state.frame === 'none') {
      frameOverlay.style.display = 'none';
      return;
    }
    var dataKey = FRAME_DATA_ATTRS[state.frame];
    var url = dataKey ? root.dataset[toCamel(dataKey)] : '';
    if (url) {
      frameOverlay.src = url;
      frameOverlay.style.display = 'block';
    } else {
      frameOverlay.style.display = 'none';
    }
  }

  function renderName() {
    if (!nameDisplay || !namePlaceholder) return;
    if (state.nameEnabled && state.name.length > 0) {
      nameDisplay.textContent = state.name;
      nameDisplay.style.fontFamily = "'" + state.nameFont + "', cursive";
      nameDisplay.style.display = 'inline';
      namePlaceholder.style.display = 'none';
    } else {
      nameDisplay.style.display = 'none';
      namePlaceholder.style.display = 'inline';
    }
  }

  function renderPreview() {
    renderMonogram();
    renderFrame();
    renderName();
  }

  // Convert "frame-scallop" → "frameScallop" for dataset access
  function toCamel(str) {
    return str.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
  }

  // Boot
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
